var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect, useCallback } from 'react';
export const usePullToRefresh = ({ onRefresh, resistance = 2, pullDownThreshold = 70, }) => {
    const [isPulling, setIsPulling] = useState(false);
    const [pullDistance, setPullDistance] = useState(0);
    const [startY, setStartY] = useState(null);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const handleTouchStart = useCallback((e) => {
        if (window.scrollY === 0 &&
            !isRefreshing &&
            e.touches.length === 1) {
            setStartY(e.touches[0].clientY);
            // setIsPulling(true);
        }
    }, [isRefreshing]);
    const handleTouchMove = useCallback((e) => {
        if (startY === null || isRefreshing) {
            return;
        }
        const currentY = e.touches[0].clientY;
        const distance = (currentY - startY) / resistance;
        if (distance > 0) {
            e.preventDefault(); // Prevent default only during pull-down
            setPullDistance(distance);
            setIsPulling(true);
        }
        else {
            // If user scrolls up, cancel the pull
            setIsPulling(false);
            setPullDistance(0);
            setStartY(null);
        }
    }, [isPulling, startY, resistance, isRefreshing]);
    const handleTouchEnd = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (isPulling) {
            if (pullDistance >= pullDownThreshold && !isRefreshing) {
                setIsRefreshing(true);
                try {
                    yield onRefresh();
                }
                catch (error) {
                    console.error('Refresh failed:', error);
                }
                finally {
                    setIsRefreshing(false);
                }
            }
            // Reset the pull state
            setIsPulling(false);
            setPullDistance(0);
            setStartY(null);
        }
    }), [isPulling, pullDistance, pullDownThreshold, onRefresh, isRefreshing]);
    useEffect(() => {
        window.addEventListener('touchstart', handleTouchStart, {
            passive: false,
        });
        window.addEventListener('touchmove', handleTouchMove, {
            passive: false,
        });
        window.addEventListener('touchend', handleTouchEnd);
        window.addEventListener('touchcancel', handleTouchEnd);
        return () => {
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
            window.removeEventListener('touchcancel', handleTouchEnd);
        };
    }, [handleTouchStart, handleTouchMove, handleTouchEnd]);
    return { isPulling, pullDistance };
};
